import { Button, Col, Form } from 'react-bootstrap';
import React from 'react';
import { useForm } from 'react-hook-form';
import { Auth } from 'aws-amplify';
import { toast } from '../../../../toaster/toast';

interface ConfirmProps {
  changeToLogin: Function;
  username?: string;
  hideSignInModal: Function;
  setShowConfirm: Function;
}

function Confirm({ changeToLogin, username, hideSignInModal, setShowConfirm }: ConfirmProps) {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors }
  } = useForm();

  async function confirmSignUp(data: any) {
    try {
      await Auth.confirmSignUp(data.username, data.code);
      toast.success('success confirming sign up, you can login now.');
      setShowConfirm(false);
      changeToLogin();
    } catch (error: any) {
      console.log('error confirming sign up', error);
      toast.error(error.message);
    }
  }

  async function resendConfirmationCode() {
    try {
      await Auth.resendSignUp(getValues('username'));
      console.log('code resent successfully');
      toast.success('code resent successfully');
    } catch (err: any) {
      console.log('error resending code: ', err);
      toast.error(err.message);
    }
  }

  return (
    <Col xs={12} className="gray-background-sign single-page-modal">
      <div>
        <button className="close" onClick={() => hideSignInModal()}>
          &times;
        </button>
      </div>
      <div className="sign-up-header">Confirm Account</div>
      <div>
        <Form onSubmit={handleSubmit(confirmSignUp)}>
          <Form.Row>
            <Form.Group as={Col} controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={username}
                placeholder="Enter email"
                {...register('username', {
                  required: 'Email required'
                })}
              />
              {errors.email && (
                <Form.Text id="emailHelpBlock" muted>
                  {errors.email.message || 'Required'}
                </Form.Text>
              )}
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="formPassword">
              <Form.Label>Code</Form.Label>
              <Form.Control type="code" placeholder="Password" {...register('code')} required />
            </Form.Group>
          </Form.Row>

          <Form.Row className="py-3 m-0">
            <Button variant="dark" type="submit" className="create-account">
              Confirm
            </Button>
          </Form.Row>
          <Form.Row className="py-3 m-0">
            <Button variant="dark" type="button" className="create-account" onClick={resendConfirmationCode}>
              Resend confirmation code
            </Button>
          </Form.Row>
        </Form>
      </div>
    </Col>
  );
}

export default Confirm;
